import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAV_ITEMS } from './navItems';
import Container from './Container';

/**
 * Desktop header. Hidden below lg, where the bottom nav takes over.
 * Both navigations render simultaneously in the DOM and are separated by
 * CSS, so their landmark names must differ.
 */
const TopNav: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <header className="hidden lg:block sticky top-0 z-[900] bg-brand-50/95 backdrop-blur border-0 border-b border-solid border-brand-300">
      <Container className="flex items-center justify-between h-20">
        <button
          type="button"
          onClick={() => navigate('/home')}
          className="bg-transparent border-0 cursor-pointer p-0"
        >
          <img src="/images/bonia/Bonia-Logo-01.png" alt="Bonia" className="h-10 w-auto" />
        </button>

        <nav aria-label="Primary desktop" className="flex items-center gap-10">
          {NAV_ITEMS.map(({ path, labelKey }) => {
            const active = pathname === path;
            return (
              <button
                key={path}
                type="button"
                onClick={() => navigate(path)}
                aria-current={active ? 'page' : undefined}
                className={
                  'bg-transparent border-0 cursor-pointer p-0 text-xs uppercase ' +
                  'tracking-[0.14em] transition-colors duration-150 ' +
                  (active
                    ? 'text-brand-900 font-semibold border-b-2 border-solid border-accent-500 pb-1'
                    : 'text-brand-600 hover:text-brand-900 pb-1 border-b-2 border-solid border-transparent')
                }
              >
                {t(labelKey)}
              </button>
            );
          })}
        </nav>
      </Container>
    </header>
  );
};

export default TopNav;
